import { render, staticRenderFns } from "./OuterFormConfig.vue?vue&type=template&id=3c9322a2&scoped=true"
import script from "./OuterFormConfig.vue?vue&type=script&lang=js"
export * from "./OuterFormConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9322a2",
  null
  
)

export default component.exports